import { QueryObserverResult, RefetchOptions } from '@tanstack/react-query';
import { FC, useMemo } from 'react';
import { useAppSelector } from '@redux/store';

import { EmptyListSection } from '@3.0/index';
import InfoBanner from '@3.0/InfoBanner';
import { ERROR_LABELS, TDataSourceTypesAllowed } from '../IngestionByDataSource.constants';

type TProps = {
  refetch: (options?: RefetchOptions) => Promise<QueryObserverResult<any, Error>>;
};

const ListError: FC<TProps> = ({ refetch }) => {
  const selectedDataSource = useAppSelector(
    (state) => state.ingestionDataSourceList.selectedDataSource
  );

  const errorDetails = useMemo(() => {
    if (selectedDataSource === null) {
      return ERROR_LABELS.dataSources;
    }

    return (
      ERROR_LABELS.tables?.[selectedDataSource.dataSourceType as TDataSourceTypesAllowed] || ''
    );
  }, [selectedDataSource]);

  return (
    <div
      className="tw:flex tw:flex-col tw:items-center tw:justify-center tw:h-full"
      data-testid="ingestion-datasource-list-error"
    >
      <InfoBanner
        className="tw:top-0 tw:left-0 tw:w-full"
        label={errorDetails}
        testId="ingestion-datasource-list-error-banner"
        variant={'error'}
      />
      <EmptyListSection showRetry retryFn={refetch}></EmptyListSection>
    </div>
  );
};
export default ListError;
